import React from 'react'
import Logo from 'assets/images/kiddy-logo.svg'
import { Layout } from 'antd'
import styles from './Header.module.scss'
import GuestRightNav from './RightNav/GuestRightNav'

const { Header } = Layout

const HeaderGuest = () => {

  return (
    <Header className = {styles.header}>
      <div>
        <a id='logo' href='/'>
          <img alt = 'logo' src = {Logo}/>
        </a>
      </div>
      <GuestRightNav />
    </Header>
  )
}

export default HeaderGuest